import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { Role } from '../../shared/models';

@Component({
  selector: 'app-company-roles',
  templateUrl: './company-roles.component.html',
  styleUrls: ['./company-roles.component.scss'],
})
export class CompanyRolesComponent implements AfterViewInit {
  @Input()
  set roles(roles: Role[]) {
    this.dataSource = new MatTableDataSource(roles);
    this.sortData({ active: this.sortActive || 'name', direction: this.sortDirection || 'asc' });
  }
  @Input() loading: boolean;
  @Output() deleteRole: EventEmitter<any> = new EventEmitter();
  @Output() roleSelected: EventEmitter<any> = new EventEmitter();

  displayedColumns: string[] = [
    'name',
    'nusers',
    'ssoIds',
    'creator',
    'createDate',
    'modifier',
    'modifyDate',
    'action',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @ViewChild(MatSort) matSort: MatSort;
  sortActive = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';

  ngAfterViewInit() {
    this.dataSource.sort = this.matSort;
  }

  sortData($event) {
    const { active, direction } = $event;
    this.sortActive = active;
    this.sortDirection = direction;
    const listSorted = this.dataSource.data.sort((a: any, b: any) => {
      let result;
      switch (active) {
        case 'name':
          result = (a[active] || '').localeCompare(b[active]);
          break;
        case 'creator':
          result = (a.created_by.admin_user_name || '').localeCompare(b.created_by.admin_user_name);
          break;
        case 'modifier':
          result = (a.last_modified_by.email || '').localeCompare(b.last_modified_by.email);
          break;
        case 'nusers':
        case 'ssoIds':
          result = a.nusers - b.nusers;
          break;
        case 'createDate':
          result = moment(a.created_by.when).isSameOrBefore(b.created_by.when) ? 1 : -1;
          break;
        case 'modifyDate':
          result = moment(a.last_modified_by.when).isSameOrBefore(b.last_modified_by.when) ? 1 : -1;
          break;
        default:
          break;
      }
      return result;
    });
    this.dataSource.data = direction === 'desc' ? listSorted.reverse() : listSorted;
  }
}
